import { css } from '@emotion/core'
import theme from 'Theme'
import { smallOnly } from 'Utils'

const {
  colors,
  typography,
  spacing,
  zIndex,
  mixins,
  components: { filterPanels }
} = theme

const { filterPanelHeader, filterPanelListItem } = mixins

const actionsHeight = '70px'
// .filter-panel__header height = 65px
const headerAndButtonHeight = '135px'

export default () => css`
  position: fixed;
  width: 100%;
  height: 100%;
  background-color: ${filterPanels.backgroundColor};
  top: 0;
  left: 0;
  z-index: ${zIndex.filterPanel.activePanel};

  .dialog-view > div {
  }

  span.items-found__label {
    text-align: left;
  }

  .icon_arrow_right {
    fill: none;
    stroke: #333;
    stroke-width: 1.5px;
  }

  div.applied-filters__link.false {
    margin-bottom: 0;
  }

  .filter-panel__header {
    ${filterPanelHeader(theme)}
    padding-left: 0;
    padding-right: 0;
  }

  .links {
    margin-top: ${spacing.vertical.xsmall};
  }

  .filter-panel__menu {
    z-index: ${zIndex.filterPanel.menu};

    .items-found {
      padding: 10px 10px 0 10px;
      margin-bottom: 10px;
    }

    .applied-filters {
      padding: 0 10px;
      max-width: 100%;
      width: 100%;
      border-bottom: 1px solid ${colors.borderGrey};
    }

    > a {
      width: 100%;
      ${filterPanelListItem(theme)};
      padding: 0 15px 0 10px;
      border-bottom: 1px solid ${colors.mobileBorderLine};
      justify-content: space-between;
    }
  }

  .filter-panel__filter {
    z-index: ${zIndex.filterPanel.panel};
  }

  .panel {
    position: static;
    height: calc(100vh - ${headerAndButtonHeight});
    ${mixins.transparencyGradient()}
    &.filter-panel__filter {
      margin-bottom: 0;
    }
  }

  .loader-container {
    display: none;
  }

  &.active {
    .filter-panel__filter {
      background-color: ${filterPanels.backgroundColor};
      z-index: ${zIndex.filterPanel.activePanel};

      /* spinner */
      .loader-container {
        display: block;
        position: fixed !important;
        width: 95%;
        height: 78%;

        .loader,
        .loader:after {
          border-radius: 50%;
          width: 64px;
          height: 64px;
        }

        .loader {
          border-top: 0.5em solid rgba(0, 0, 0, 0.4);
          border-right: 0.5em solid rgba(0, 0, 0, 0.4);
          border-bottom: 0.5em solid rgba(0, 0, 0, 0.4);
          border-left: 0.5em solid #000;
        }
      }
    }

    .store-filter {
      .spinner {
        display: none;
      }
    }
  }

  .filter-panel__actions {
    height: ${actionsHeight};
    width: 100%;
    position: fixed;
    z-index: 999;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    justify-content: space-between;
    > * {
      appearance: none;
      display: table-cell;
      vertical-align: middle;
      min-width: 40%;
      width: 100%;
      height: calc(${actionsHeight} - 20px);
      margin: 10px;
      border: 1px solid ${colors.primary};
      background-color: ${colors.complementary.primary};
      &:disabled {
        border: 1px solid ${colors.button.disabled};
        color: ${colors.button.disabled};
      }
    }
  }

  .filter-panel__title {
    text-align: center;
    font-size: ${typography.sizes.large};
    font-weight: normal;
    width: 100%;
  }

  .back-to-menu {
    position: absolute;
    top: 10px;
    left: 0;
    padding: 8px;

    svg {
      display: block;
      transform: rotate(180deg);
      width: 22px;
      height: 12px;
    }

    &:hover {
      cursor: pointer;
    }
  }

  .close-modal__wrapper {
    position: absolute;
    right: 0;
    z-index: ${zIndex.filterPanel.closeDialog};
    width: 50px;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .close-modal {
    fill: ${colors.complementary.primary};
  }

  .panel-buttons__apply {
    &.disabled {
      background-color: ${filterPanels.diabledBackground};
      color: ${filterPanels.disabledText};
    }
  }

  .price-filter-container {
    width: 100%;
  }

  .sale-filter {
    display: block;
    @media ${smallOnly} {
      a,
      span {
        width: 100%;
        &.disabled {
          color: ${colors.disabled};
        }
      }
    }
  }

  .store-filter {
    width: 100%;
    height: 100%;
    padding: 0 16px;

    .list {
      max-height: calc(100vh - ${actionsHeight});
      overflow-y: scroll;
    }

    @media ${smallOnly} {
      height: calc(100vh - 130px);
      padding: 0;

      .list {
        max-height: calc(100vh - 200px);
        padding: 0;
        .list-item {
          span {
            display: inline;
          }
        }
      }
    }
  }

  .sorting-panel {
    .labeled-checkbox {
      margin-bottom: 12px;
      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  .price-filter-container {
    > * {
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
`
